import $ from 'jquery';
import Dropzone from 'dropzone';
import slugify from 'slugify';
import { getAxiosClient } from './api';
import { modifyState } from '~src/state';
import { getUser } from '~src/user';
import { fetchLogos } from '~src/sidebar/logo';
import { displaySidebarLogos, handleSidebarLogos } from '~src/sidebar/index';

Dropzone.autoDiscover = false;

export const uploadLogo = async (base64String, filename) => {
  const httpClient = await getAxiosClient();

  const data = {
    toFile_logo: {
      b64: base64String,
      name: slugify(filename, {
        strict: true, // strip special characters except replacement, defaults to `false`
      }),
    },
  };
  const { user } = await getUser();

  return httpClient.put(
    `${process.env.PARSE_API_URL}/organizzazione/${user.org_pointer.objectId}`,
    {
      data,
    }
  );
};

export const createDropzoneLogo = () => {
  var previewTemplate = `<div
  class="items-tag-image-container m-0">
    <img
        src="../assets/svg/img-loader.gif"
        class="lazy items-tag-image mt-5"
    />
  </div>`;
  const dropzoneLogo = new Dropzone('#box-logo', {
    maxFiles: 1,
    init: function () {
      this.on('maxfilesexceeded', function (file) {
        this.removeAllFiles();
        this.addFile(file);
      });
    },
    autoProcessQueue: false,
    url: '/',
    timeout: 0,
    previewTemplate: previewTemplate,
    acceptedFiles: 'image/jpeg,image/png,image/svg+xml',
    previewsContainer: '#editor-sidebar-logo', // Define the container to display the previews
    clickable: '#editor-sidebar-upload-btn-logo', // Define the element that should be used as click trigger to select files.
  });

  dropzoneLogo.on('addedfile', (file) => {
    $('#containerTextEmptyBoxLogo').remove();

    setTimeout(() => {
      if (typeof file.accepted !== 'undefined' && file.accepted === false) {
        console.error('File not accepted', file);
        return;
      }

      const reader = new FileReader();
      reader.onload = async (event) => {
        const base64String = event.target.result;
        const fileName = file.name;

        try {
          await uploadLogo(base64String, fileName);

          file.previewElement.classList.add('dz-success');
          const { items } = await fetchLogos(true);
          window.editorConfig.sidebarLogo = items;
          displaySidebarLogos();
          handleSidebarLogos();
        } catch (error) {
          file.previewElement.classList.add('dz-error');
          $('.dz-error-message span').text('Upload fallito, riprovare');
        }
      };
      reader.readAsDataURL(file);
    }, 100);
  });

  modifyState('dropzoneLogo', dropzoneLogo);
};
